import { Directive, ElementRef, Input, OnInit } from "@angular/core";
@Directive({ standalone: false, selector: "[appBtnAutoFocus]" })
export class BtnAutoFocus implements OnInit {
  @Input("appBtnAutoFocus") focus?: boolean;
  constructor(private el: ElementRef) {
    if (this.focus && !el.nativeElement["focus"]) {
      throw new Error("Element does not accept focus");
    }
  }
  ngOnInit() {
    if (this.focus) {
      const button: HTMLButtonElement = this.el
        .nativeElement as HTMLButtonElement;
      button.focus();
    }
  }
}
